const RESOURCE_PATH = '/sparing-child-account-web/rest/resource';

const BASE_PATH = `${RESOURCE_PATH}/api`;

export const getResourceUrl = (path: string) => `${RESOURCE_PATH}/${path}`;
export const getApiUrl = (path: string) => `${BASE_PATH}/${path}`;
